// Adapted from https://halistechnology.com/2015/05/28/use-javascript-to-export-your-data-as-csv/

import { saveAs } from 'file-saver'

export function toCsv(data) {
  if (!data || data.length === 0) return
  let columnDelimiter = ','
  let lineDelimiter = '\n'

  let keys = Object.keys(data[0])

  let result = ''
  result += keys.join(columnDelimiter)
  result += lineDelimiter

  data.forEach(function(item) {
    let ctr = 0
    keys.forEach(function(key) {
      if (ctr > 0) result += columnDelimiter

      result += item[key]
      ctr++
    })
    result += lineDelimiter
  })

  return result
}

export function downloadCsv(filename, data) {
  let csv = toCsv(data)
  let blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
  saveAs(blob, filename)
}
